import { render, staticRenderFns } from "./AddVendor.vue?vue&type=template&id=c3480664"
import script from "./AddVendor.vue?vue&type=script&lang=js"
export * from "./AddVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3480664')) {
      api.createRecord('c3480664', component.options)
    } else {
      api.reload('c3480664', component.options)
    }
    module.hot.accept("./AddVendor.vue?vue&type=template&id=c3480664", function () {
      api.rerender('c3480664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/widgets/AddVendor.vue"
export default component.exports